import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from '../components/Index.vue'
import ContactForm from '../components/ContactForm.vue'
import ReportForm from '../components/ReportForm.vue'
import ReportSection from '../components/ReportSection.vue'
import ReportImages from '../components/ReportImages.vue'
import Reports from '../components/Reports.vue'
import ReportsLogs from '../components/ReportsLogs.vue'
import Editor from '../components/Editor.vue'
import DepartmentEditor from '../components/EditorDepartment.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name:'index',
        component: Index
    },
    {
        name: 'report-new',
        path: '/reports/new',
        component: ContactForm
    },
    {
        name: 'report-section',
        path: '/reports/:id/section/:num',
        component: ReportSection
    },
    {
        name: 'report-images',
        path: '/reports/:id/images/:num',
        component: ReportImages
    },
    {
        name: 'report-contact',
        path: '/reports/:id/contact',
        component: ContactForm
    },
    {
        path: '/reports/logs/:license?',
        name:'reports-logs',
        component: ReportsLogs
    },
    {
        path: '/reports/code/:code',
        name:'reports-code',
        component: ReportForm
    },
    {
        name: 'report',
        path: '/reports/:id',
        component: ReportForm
    },
    {
        path: '/reports',
        name:'reports',
        component: Reports
    },
    {
        path: '/editor',
        name: 'editor',
        component: Editor
    },
    {
        path: '/department',
        name: 'new-department',
        component: DepartmentEditor
    },
    {
        path: '/department/:id',
        name: 'department',
        component: DepartmentEditor
    },

    {path: '',redirect: '/'},
    {path: '*',redirect: '/'}
]

const router = new VueRouter({
    routes: routes
});
/*
router.afterEach((to, from, next) => {
    if( to.name == 'reports-code' ){
        //next();
    }
    console.log(router.app.user.roles);

    if( to.name != 'reports-code' && !router.app.user.roles.length ){
        //window.location.href = data.location.replace(/url_redirect_url/i, encodeURIComponent(window.location.href))
    }
    console.log(to);
    console.log(from);
    console.log(this);
    console.log(router);

    //next();
})

router.beforeEach((to, from, next) => {
    if( to.name == 'reports-code' ){
        next();
    }
    console.log(router.app.$root.user.roles);

    if( to.name != 'reports-code' && !router.app.user.roles.length ){
        //window.location.href = data.location.replace(/url_redirect_url/i, encodeURIComponent(window.location.href))
    }
    console.log(to);
    console.log(from);
    console.log(this);
    console.log(router);

    next();
})
*/
export default router




// WEBPACK FOOTER //
// ./reports/assets/src/router/index.js